import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, Select, Textfield, Toolbar, ToolbarSection } from "cxa-components";
import messages from "components/messagesDescription";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { pageSizePresets } from "reducers/libraryCatalogueReducer";
import ToggleButton from "./ToggleButton";
import { FilterIcon, SortIcon } from "cxa-icons";

const SortByFilter = ({ options, value, onChange, intl }) => (
  <p>
    <span className="cxa-c-form__select-box">
      <Select name="sortBy" id="sortByDropDown" onChange={onChange} onBlur={onChange} value={value}>
        {options &&
          options.map(({ name, value }) => (
            <option key={value} value={value}>
              {intl.formatMessage({ id: name, defaultMessage: name })}
            </option>
          ))}
      </Select>
    </span>
  </p>
);

SortByFilter.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  intl: intlShape.isRequired,
};

export const getAltPageSize = pageSize => {
  return pageSize === pageSizePresets.lower ? pageSizePresets.upper : pageSizePresets.lower;
};

class _SearchFilter extends Component {
  state = {
    search: "",
    isFilterShown: false,
    isSortShown: false,
  };

  render() {
    const {
      intl,
      filterBox: FilterComponent,
      filterParams,
      onSearchSubmit,
      onTogglePageSize,
      pageSize,
      sortOptions,
      sortValue,
      onSortChange,
    } = this.props;

    return (
      <Toolbar className="apl-search__toolbar">
        <ToolbarSection>
          <ToggleButton
            label="Filters"
            className="apl-toggle-button__iconic apl-icon"
            icon={FilterIcon}
          >
            {filterParams && <FilterComponent {...filterParams} />}
          </ToggleButton>
        </ToolbarSection>
        <ToolbarSection>
          <ToggleButton label="Sort" className="apl-toggle-button__iconic apl-icon" icon={SortIcon}>
            <SortByFilter
              options={sortOptions}
              value={sortValue}
              onChange={onSortChange}
              intl={intl}
            />
          </ToggleButton>
        </ToolbarSection>
        <ToolbarSection className="apl-search__page-toggle">
          <p>
            <Button primary onClick={onTogglePageSize} type="button" compact>
              {intl.formatMessage(messages.viewPagesDescription, {
                pageSize: getAltPageSize(pageSize),
              })}
            </Button>
          </p>
        </ToolbarSection>
        <ToolbarSection className="apl-search__form">
          <form
            onSubmit={e => {
              e.preventDefault();
              onSearchSubmit(e.target.search.value);
            }}
            className="form--search"
          >
            <p>
              <input
                boxed
                size="80"
                id="search"
                name="search"
                className="textfield textfield--boxed"
                placeholder={intl.formatMessage(messages.searchTextDescription)}
              />
            </p>
            <p>
              <Button primary compact>
                <FormattedMessage {...messages.searchTextDescription} />
              </Button>
            </p>
          </form>
        </ToolbarSection>
      </Toolbar>
    );
  }
}

_SearchFilter.propTypes = {
  filterBox: PropTypes.func,
  filterParams: PropTypes.object,
  onSearchSubmit: PropTypes.func,
  onTogglePageSize: PropTypes.func,
  pageSize: PropTypes.number,
  sortOptions: PropTypes.array,
  sortValue: PropTypes.string,
  onSortChange: PropTypes.func,
  intl: intlShape.isRequired,
};

export const SearchFilter = injectIntl(_SearchFilter);



// WEBPACK FOOTER //
// ./components/common/SearchFilter.js